import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { CartProvider } from "./context/CartContext";
import { BusinessProvider } from "./context/BusinessContext";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminBusiness from "./pages/admin/AdminBusiness";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BusinessProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors theme="light" />
              <Routes>
                <Route path="/" element={<Shell><Home /></Shell>} />
                <Route path="/shop" element={<Shell><Shop /></Shell>} />
                <Route path="/product/:id" element={<Shell><ProductDetail /></Shell>} />
                <Route path="/cart" element={<Shell><Cart /></Shell>} />
                <Route path="/checkout" element={<Shell><Checkout /></Shell>} />
                <Route path="/order/success" element={<Shell><OrderSuccess /></Shell>} />
                <Route path="/order/:id" element={<Shell><OrderSuccess /></Shell>} />

                <Route path="/admin" element={<Shell><AdminLogin /></Shell>} />
                <Route element={<Shell><AdminLayout /></Shell>}>
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/admin/products" element={<AdminProducts />} />
                  <Route path="/admin/categories" element={<AdminCategories />} />
                  <Route path="/admin/orders" element={<AdminOrders />} />
                  <Route path="/admin/business" element={<AdminBusiness />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </BusinessProvider>
    </div>
  );
}
